// features/admin/adminSaga1.js
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchCountryRequest,
  fetchCountrySuccess,
  fetchCountryFailure,
  createCountryRequest,
  createCountrySuccess,
  createCountryFailure,
  updateCountryRequest,
  updateCountrySuccess,
  updateCountryFailure,
  assignCountriesRequest,
  assignCountriesSuccess,
  assignCountriesFailure,
  removeCountryRequest,
  removeCountrySuccess,
  removeCountryFailure,
  getActiveCountriesRequest,
  getActiveCountriesSuccess,
  getActiveCountriesFailure,
} from "../CountryList/CountrySlice";
import axios from "axios";
import { toast } from "react-toastify";

// Fetch Admins
function* fetchCountry(action) {
  try {
    const payload = action.payload || { page: 0, limit: 5, search: "" };
    const start = payload.page * payload.limit;

    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/country-code-management/get-all-countries`,
        {
          params: {
            start,
            limit: payload.limit,
            search: payload.search,
          },
        }
      )
    );

    const result = response.data;
    const countries = result.data?.data || [];
    const total = result.data?.total || 0;

    const countryArray = countries.map((country, index) => ({
      id: start + index + 1,
      _id: country._id,
      countryName: country.countryName,
      countryCode: country.countryCode,
      dialCode: country.dialCode,
      currency: country.currency,
      currencySymbol: country.currencySymbol,
      phoneLength: country.phoneLength,
      isenabled: country.isenabled,
      states: country.states || [],
    }));

    yield put(
      fetchCountrySuccess({
        data: countryArray,
        total,
        page: payload.page,
        limit: payload.limit,
      })
    );
  } catch (error) {
    console.error("Country list fetch failed:", error);
    yield put(
      fetchCountryFailure(error.response?.data?.message || error.message)
    );
  }
}

// Create Admin
function* createCountry(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/country-code-management/create-country`,
      action.payload
    );
    yield put(createCountrySuccess(response.data));
    // Optionally refresh list
    yield put(fetchCountryRequest());
  } catch (error) {
    yield put(
      createCountryFailure(error.response?.data?.message || error.message)
    );
  }
}

// Edit
function* updateCountry(action) {
  try {
    const { _id, ...countryData } = action.payload;

    const response = yield call(
      axios.patch,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/country-code-management/update-country-details?id=${_id}`,
      countryData
    );

    yield put(updateCountrySuccess(response.data));
    // Optionally refresh list
    yield put(fetchCountryRequest({ page: 0, limit: 5 }));
  } catch (error) {
    yield put(
      updateCountryFailure(error.response?.data?.message || error.message)
    );
  }
}

function* assignCountries(action) {
  try {
    const { id } = action.payload;

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/country-code-management/assgin-countries?id=${id}`
    );
    const resData = response.data;
    if (resData.success) {
      toast.success(resData.message || "Countries assigned successfully!");
    } else {
      toast.error(resData.message || "Something went wrong!");
    }

    yield put(assignCountriesSuccess(response.data));
    yield put(fetchCountryRequest({ page: 0, limit: 5 }));
  } catch (error) {
    console.error("Assign countries failed:", error);
    yield put(
      assignCountriesFailure(error.response?.data?.message || error.message)
    );
  }
}

function* removeCountry(action) {
  try {
    const { id } = action.payload;

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/country-code-management/remove-countries?id=${id}`
    );

    const resData = response.data;

    if (resData.success) {
      toast.success(resData.message || "Country removed successfully!");
    } else {
      toast.error(resData.message || "Failed to remove country!");
    }

    yield put(removeCountrySuccess(resData));

    // refresh list after removal
    yield put(fetchCountryRequest({ page: 0, limit: 5 }));
  } catch (error) {
    console.error("Remove country failed:", error);
    yield put(
      removeCountryFailure(error.response?.data?.message || error.message)
    );
    toast.error(error.response?.data?.message || "API error occurred!");
  }
}

function* getActiveCountriesSaga({ payload }) {
  try {
    const token = `${process.env.REACT_APP_PUBLIC_TOKEN}`

    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/country-code-management/get-active-countries`,
        payload,
      )
    );

    if (response.data.success) {
      yield put(getActiveCountriesSuccess(response.data.data));
    //  toast.success(response.data.message || "Fetched active countries!");
    } else {
      yield put(getActiveCountriesFailure(response.data.message));
      toast.error(response.data.message || "Failed to fetch countries!");
    }
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    yield put(getActiveCountriesFailure(message));
    toast.error(`Failed to fetch active countries: ${message}`);
  }
}

export default function* countrySaga() {
  yield takeLatest(fetchCountryRequest.type, fetchCountry);
  yield takeLatest(createCountryRequest.type, createCountry);
  yield takeLatest(updateCountryRequest.type, updateCountry);
  yield takeLatest(assignCountriesRequest.type, assignCountries);
  yield takeLatest(removeCountryRequest.type, removeCountry);
  yield takeLatest(getActiveCountriesRequest.type, getActiveCountriesSaga);
}
